import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosRequestHeaders } from "axios";
import { getInvestorApiUrl } from "../../utils/config";
import { ApiRequestParams, handleFetchApi } from "../../utils/api";

// Define types for better type safety
interface UploadDocumentResponse {
  // Add response structure here based on your API
  success: boolean;
  message: string;
  // other response fields
}

interface DocumentState {
  uploadResponse: UploadDocumentResponse | null;  // To store the POST API response for file upload
  loading: boolean;        // To track loading state
  error: string;           // To track any errors
}

// Initial state for the document slice
const initialState: DocumentState = {
  uploadResponse: null,
  loading: false,
  error: "",
};

// Async thunk to post data to /kyc/Upload endpoint
export const uploadDocument = createAsyncThunk<
  UploadDocumentResponse, // Return type of the action payload
  FormData,              // Type of the argument passed to the thunk
  { rejectValue: string } // Reject type (in case of error)
>(
  "document/uploadDocument",
  async (payload, thunkApi) => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: "kyc/Upload",
        payload,
        method:"POST",
        headers: {
          "Content-Type": "multipart/form-data"
        } as AxiosRequestHeaders

      }
      const response = await handleFetchApi(params)
      // Send the POST request with the form data
      // const response = await axios.post(`${baseUrl}/kyc/Upload`, payload, {
      //   headers: {
      //     "Content-Type": "multipart/form-data", // Important header for file uploads
      //   },
      // });
      console.log(response, "responseresponse");
      return response.data.body; // Return API response
    } catch (error: any) {
      // Ensures the error is handled properly
      const errorMsg = error.response?.data || "Failed to upload document";
      return thunkApi.rejectWithValue(errorMsg); // Use rejectWithValue to return the error
    }
  }
);

const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Upload Document (POST request to /kyc/Upload)
      .addCase(uploadDocument.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(uploadDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadResponse = action.payload;
      })
      .addCase(uploadDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to upload document";
      });
  },
});

export default documentSlice.reducer;
